export default __webpack_public_path__ + "static/media/Grinning6.3c66abb0.svg";